import { useEffect } from 'react';
import SMMHero from './components/SMMHero';
import SMMDifference from './components/SMMDifference';
import SMMForWhom from './components/SMMForWhom';
import SMMWhyNeeded from './components/SMMWhyNeeded';
import SMMResult from './components/SMMResult';
import SMMProcess from './components/SMMProcess';
import SMMWhyChooseUs from './components/SMMWhyChooseUs';
import SMMPackages from './components/SMMPackages';
import SMMAddons from './components/SMMAddons';
import SMMBenefits from './components/SMMBenefits';
import SMMLeadForm from './components/SMMLeadForm';
import Footer from '../landing-page/components/Footer';
import { useSEO } from '../../utils/seo';

export default function SMMStrategyPage() {
  useSEO({
    title: 'SMM-стратегия и продвижение в соцсетях Москва | Системные продажи через социальные сети',
    description: 'Профессиональная SMM-стратегия для бизнеса: продвижение в Instagram, ВКонтакте, Telegram. Маркетинг с ИИ-агентами. Системный канал продаж, лиды и рост охватов более чем на 10%.',
    keywords: 'SMM-стратегия, продвижение в социальных сетях, SMM для бизнеса, контент-маркетинг, таргетинг',
    canonical: '/SMM-strategy',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SMMHero />
      <SMMDifference />
      <SMMForWhom />
      <SMMWhyNeeded />
      <SMMResult />
      <SMMProcess />
      <SMMWhyChooseUs />
      <SMMPackages />
      <SMMAddons />
      <SMMBenefits />
      <SMMLeadForm />
      <Footer />
    </div>
  );
}
